declare global {
  interface Config extends EnvConfig, CommonConfig {}

  interface EnvConfig {
    APP_URL: string;
    API_URL: string;
    CORESKILLS_API_URL: string;
    STAGE: string;
  }

  interface CommonConfig {
    NODE_ENV: string;
    MaxAttachmentSize: number;
  }
}

const dev: EnvConfig = {
  APP_URL: process.env.REACT_APP_APP_URL ?? 'http://localhost:3000',
  //API_URL: process.env.REACT_APP_API_URL ?? 'http://localhost:4000',
  //CORESKILLS_API_URL: process.env.REACT_APP_CORESKILLS_API_URL ?? 'http://127.0.0.1:8000',
  CORESKILLS_API_URL: process.env.REACT_APP_CORESKILLS_API_URL ?? 'https://coreskills-courses.onrender.com',
  API_URL: process.env.REACT_APP_API_URL ?? 'https://am-ajassa-api-dev.azurewebsites.net',
  //API_URL: process.env.REACT_APP_API_URL ?? 'https://api.ajassa.fi',
  STAGE: process.env.REACT_APP_STAGE ?? 'test',
};

const prod: EnvConfig = {
  APP_URL: process.env.REACT_APP_APP_URL ?? '',
  API_URL: process.env.REACT_APP_API_URL ?? '',
  CORESKILLS_API_URL: process.env.REACT_APP_CORESKILLS_API_URL ?? 'https://coreskills-courses.onrender.com',
  STAGE: process.env.REACT_APP_STAGE ?? 'production',
};

const common: CommonConfig = {
  NODE_ENV: process.env.NODE_ENV ?? 'development',
  MaxAttachmentSize: 10000000,
};

const envConfig = process.env.NODE_ENV === 'development' ? dev : prod;
const config: Config = {
  ...common,
  ...envConfig,
};

if (process.env.NODE_ENV === 'development') {
  console.log('config: ', config);
}

export default config;
